import styled from '@emotion/styled';
import { Divider, Grid } from '@kc-console/common-ui';
import { LayoutType, PageLayoutProvider } from '@kc-console/context';

import { FORM_LAYOUT_STYLE } from '../../constants/layout';
import { BannerRenderer } from '../BannerRenderer';
import { ScrollObserverRootWrapper } from '../ScrollObserverWrapper';
import {
  LayoutBannerContainerWrapper,
  LayoutBodyContainerWrapper,
  LayoutContentSectionWrapper,
  LayoutHeaderContainerWrapper,
} from './Wrapper';

import type { DefaultComponentProps, FormSectionProps } from './types';

export default function FormLayout(props: DefaultComponentProps) {
  const { className, children } = props;

  return (
    <PageLayoutProvider layoutType={LayoutType.form}>
      <FormLayoutWrapper className={className} flexDirection="row">
        {children}
      </FormLayoutWrapper>
    </PageLayoutProvider>
  );
}

export const FormSection = (props: FormSectionProps) => {
  const { headerView, children } = props;
  return (
    <>
      <ScrollObserverRootWrapper
        rootComponent={
          <FormContentSection>
            <FormBannerContainer>
              <BannerRenderer />
            </FormBannerContainer>
            <FormHeaderContainer>{headerView}</FormHeaderContainer>
            <FormDivider />
            <FormBodyContainer>{children}</FormBodyContainer>
          </FormContentSection>
        }
      />
    </>
  );
};

const FormLayoutWrapper = styled(Grid)`
  width: 100%;
`;

const FormContentSection = styled(LayoutContentSectionWrapper)`
  height: 100%;
  position: relative;
  overflow: auto;
`;

const FormBannerContainer = styled(LayoutBannerContainerWrapper)`
  min-width: ${FORM_LAYOUT_STYLE.CONTAINER_WIDTH}px;
`;

const FormHeaderContainer = styled(LayoutHeaderContainerWrapper)`
  min-width: ${FORM_LAYOUT_STYLE.CONTAINER_WIDTH}px;
`;

const FormDivider = styled(Divider)`
  min-width: ${FORM_LAYOUT_STYLE.CONTAINER_WIDTH - FORM_LAYOUT_STYLE.PADDING_HORIZONTAL * 2}px;
  margin: 0 ${FORM_LAYOUT_STYLE.PADDING_HORIZONTAL}px;
`;

const FormBodyContainer = styled(LayoutBodyContainerWrapper)`
  min-width: ${FORM_LAYOUT_STYLE.CONTAINER_WIDTH}px;
  flex-grow: 1;
`;
